import React, { useCallback, useState } from 'react';
import { ArrowDownIcon, ArrowUpIcon, Box, Button, Inscription } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  title: string;
  children?: React.ReactNode;
}

const ToggleSection: React.FC<Props> = ({ testId, title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <Box>
      <Button
        data-testId={`${testId}_toggle-section`}
        onClick={handleToggle}
        margin={{ bottom: 'spacing8' }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'start',
          minHeight: 'auto',
          height: 'auto'
        }}
      >
        <Box margin={{ right: 'spacing12' }}>
          {isExpanded ? (
            <ArrowUpIcon />
          ) : (
            <ArrowDownIcon />
          )}
        </Box>
        <Inscription weight={700}>{title}</Inscription>
      </Button>

      {isExpanded ? children : null}
    </Box>
  );
};

export default ToggleSection;
